import { Field, Form } from 'react-final-form'

import { SelectValue } from 'common/components/BaseSelect'
import Button from 'common/components/button'
import FormItem from 'common/components/formItem/FormItem'
import Input from 'common/components/input/Input'
import Modal from 'common/components/Modal'
import SingleSelect from 'common/components/singleSelect'
import { errorToast } from 'common/components/toastNotification'

import useGetAccountQuery from '../../api/queries/useGetAccountQuery'

interface Props {
  isVisible: boolean
  onClose: () => void
}
const validateName = (value: string | undefined) =>
  value?.trim() === undefined || value.trim().length === 0
    ? 'Required'
    : undefined

const validatePrivacyRegion = (value: SelectValue | undefined) => {
  if (!value) {
    return 'Select your storage location.'
  }
}

const CreateRecordModal = ({ isVisible, onClose }: Props) => {
  const handleClose = () => {
    onClose()
  }
  const accountQuery = useGetAccountQuery()

  return (
    <Modal
      className="max-w-104"
      data-cy="add-record-modal"
      data-testid="add-record-modal"
      visible={isVisible}
      closable={false}
      destroyOnClose
      centered
    >
      <div className="text-base-700 flex flex-col gap-2 mb-6">
        <div className="font-medium text-2xl">Create a record please</div>
        <div className="text-sm">
          This data source will be populated incrementally with the customer
          attributes received through your API requests.
        </div>
      </div>
      <Form<{ name: string; storageLocation: string }>
        initialValues={{
          name: '',
          storageLocation: '',
        }}
        onSubmit={() => {
          errorToast('Not implemented')
        }}
        render={({ handleSubmit, hasValidationErrors }) => (
          <form
            id="workflow-edit-form"
            onSubmit={handleSubmit}
            className="flex flex-col h-full overflow-hidden"
          >
            <Field<string> initialValue="" name="name" validate={validateName}>
              {({ input, meta }) => (
                <FormItem
                  error={meta.touched ? meta.error : undefined}
                  htmlFor={input.name}
                  label="Name"
                  className="flex-none mb-4"
                >
                  <Input
                    data-cy="edit-name-input"
                    data-testid="edit-name-input"
                    type="text"
                    variant="default"
                    className="w-full focus:bg-maroon-40"
                    onBlur={input.onBlur} // needed for meta.touched to work
                    value={input.value}
                    required
                    onChange={input.onChange}
                    name={input.name}
                    id={input.name}
                    placeholder="EU Customers data"
                  />
                </FormItem>
              )}
            </Field>
            <Field<SelectValue>
              name="storageLocation"
              validate={validatePrivacyRegion}
            >
              {({ meta, input }) => (
                <FormItem
                  label="Choose data storage location"
                  error={meta.touched ? meta.error : undefined}
                  className="w-full col-span-2"
                >
                  <SingleSelect
                    placeholder="Select your privacy region"
                    value={input.value.value}
                    options={accountQuery.data}
                    onChange={input.onChange}
                    menuPortalTarget={document.body}
                    onBlur={input.onBlur} // needed for meta.touched to work
                  />
                </FormItem>
              )}
            </Field>

            <div className="flex gap-4 mt-10 justify-end ">
              <Button
                variant="link"
                ghost
                onClick={handleClose}
                data-cy="cancel"
                data-testid="cancel"
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                data-cy="create"
                data-testid="create"
                disabled={hasValidationErrors}
              >
                Create
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  )
}

export default CreateRecordModal
